document.addEventListener("DOMContentLoaded", () => {
  const liveRegion = document.getElementById("live-region");

  // Initial close
  document.querySelectorAll(".accordion_content, .sub_a").forEach(el => {
    el.classList.remove("show");
  });

  /* -------- First Level Accordion -------- */
  document.querySelectorAll(".accordion > li > a").forEach(trigger => {
    trigger.addEventListener("click", e => {
      e.preventDefault();

      const content = trigger.nextElementSibling;
      const li = trigger.parentElement;

      // Close others
      document.querySelectorAll(".accordion_content").forEach(item => {
        if (item !== content) {
          item.classList.remove("show");
          item.parentElement.classList.remove("active");

          const a = item.parentElement.querySelector("a");
          a.setAttribute("aria-expanded", "false");
          a.setAttribute("toggle", "false");
        }
      });

      const isOpen = content.classList.toggle("show");

      trigger.setAttribute("aria-expanded", isOpen);
      trigger.setAttribute("toggle", isOpen);
      li.classList.toggle("active", isOpen);

      liveRegion.textContent =
        trigger.querySelector("span")?.textContent +
        (isOpen ? " expanded" : " collapsed");
    });
  });

  /* -------- Second Level Accordion -------- */
  document.querySelectorAll(".sub_q").forEach(question => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;

      // Close others
      document.querySelectorAll(".sub_a").forEach(item => {
        if (item !== answer) {
          item.classList.remove("show");
          item.previousElementSibling.setAttribute("aria-expanded", "false");
          item.previousElementSibling.setAttribute("toggle", "false");
        }
      });

      const isOpen = answer.classList.toggle("show");

      question.setAttribute("aria-expanded", isOpen);
      question.setAttribute("toggle", isOpen);

      liveRegion.textContent =
        question.textContent + (isOpen ? " expanded" : " collapsed");
    });
  });
});
